import { Gavel } from "lucide-react";
import { Countdown } from "@/components/countdown";
import { formatGBP } from "@/lib/format";

/**
 * Compact fixed bottom bar shown on <lg viewports for active auctions.
 * Clicking "Bid" scrolls the main bid form into view; submission logic stays there.
 */
export function MobileBidBar({
  currentBidPence,
  endTime,
  onBid,
  disabled,
}: {
  currentBidPence: number;
  endTime: string;
  onBid: () => void;
  disabled?: boolean;
}) {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 lg:hidden border-t border-border/60 bg-background/95 backdrop-blur-xl shadow-[0_-10px_40px_-15px_rgba(139,92,246,0.35)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      role="region"
      aria-label="Auction bidding"
    >
      <div className="flex items-center justify-between gap-3 px-4 py-2.5">
        <div className="min-w-0">
          <p className="text-[10px] uppercase tracking-widest text-muted-foreground">Current bid</p>
          <p className="font-display text-lg text-gold-gradient truncate">
            {formatGBP(currentBidPence)}
          </p>
          <Countdown endTime={endTime} className="text-[11px]" />
        </div>
        <button
          type="button"
          onClick={onBid}
          disabled={disabled}
          className="inline-flex h-11 min-w-[130px] items-center justify-center gap-2 rounded-lg bg-gold-gradient px-5 text-sm font-medium text-gold-foreground shadow-[0_10px_30px_-10px_rgba(212,175,55,0.5)] press-tap disabled:opacity-60"
        >
          <Gavel className="h-4 w-4" /> Place bid
        </button>
      </div>
    </div>
  );
}
